var SchoolOrgList = require("components/appdev/wizards/SchoolOrgList");

require("appdev/appdev_home_page.scss");

class AppdevHomePage extends React.Component {
	constructor(props) {
		super();
		autobind(this);

		this.state = { loadSchools: false }
	}

	render() {

		return (
			<div className="appdevHomePage container">

				<div className="headerSection">
					<header className="pageHeader">
						<h1>Wizards</h1>
					</header>
				</div>

				<div className="quickLinks">
					<h3>Quick Links</h3>
					<div className="row">
						<div className="col-md-6">
							<div className="linkSection">
								<h4>School Org Management</h4>
								<ul>
									<li>
										<a href="/direct_school_org">
											<strong>Direct School/District Org Creation</strong>
										</a>
										<span className="badge badge-success">NEW</span>
										<div className="linkDescription">
											Create school or district orgs directly, bypassing ZDS (recommended when ZDS is down)
										</div>
									</li>
									<li>
										<a href="/new_school_org">School Org (via ZDS Deal)</a>
									<span className="badge badge-warning">OLD</span>
									<div className="linkDescription">
										Traditional workflow requiring ZDS Deal (currently broken)
									</div>
								</li>
								<li>
									<a href="/new_school">New School (Cheshire)</a>
									<span className="badge badge-warning">OLD</span>
										<div className="linkDescription">
											Create canonical school + ZDS contact (currently broken)
										</div>
									</li>
									<li>
										<a href="/school_orgs">Browse School Orgs</a>
									</li>
									<li>
										<a href="/district_orgs">Browse District Orgs</a>
									</li>
								</ul>
							</div>
						</div>
						<div className="col-md-6">
							<div className="linkSection">
								<h4>CRM & Deals</h4>
								<ul>
									<li>
										<a href="/new_deal">New Deal</a>
										<div className="linkDescription">
											Create deal in ZDS (currently broken)
										</div>
									</li>
									<li>
										<a href="/new_quotes">New Quotes</a>
									</li>
									<li>
										<a href="/received">Deal Received</a>
									</li>
									<li>
										<a href="/deal_transforms">Deal Transforms</a>
									</li>
									<li>
										<a href="/upgrade_tokens">Upgrade Tokens</a>
									</li>
									<li>
										<a href="/discount_tokens">Discount Tokens</a>
									</li>
								</ul>
							</div>
						</div>
					</div>
					<div className="row">
						<div className="col-md-6">
							<div className="linkSection">
								<h4>User Management</h4>
								<ul>
									<li>
										<a href="/users/search">Power Drill (User Search)</a>
									</li>
									<li>
										<a href="/merge_students">Merge Students</a>
									</li>
								</ul>
							</div>
						</div>
						<div className="col-md-6">
							<div className="linkSection">
								<h4>Other Tools</h4>
								<ul>
									<li>
										<a href="/screenshot_data">Screenshot Data</a>
									</li>
									<li>
										<a href="/warmup_display">Warmup Question Display</a>
									</li>
									<li>
										<a href="/digests_page">Digests</a>
									</li>
								</ul>
							</div>
						</div>
					</div>
				</div>

				<div className="text-center wizardsQuote">
					<div className="text-left" style={{ display: "inline-block" }}>
						<p>"But I don’t want to go among mad people," <span className="lightGray">Alice remarked.</span></p>
						<p>"Oh, you can’t help that," <span className="lightGray">said the Cat:</span> "we’re all mad here. I’m mad. You’re mad."</p>
						<p>"How do you know I’m mad?" <span className="lightGray">said Alice.</span></p>
						<p>"You must be," <span className="lightGray">said the Cat,</span> "or you wouldn’t have come here."</p>
					</div>
				</div>
				
			</div>
		)
	}
};

AppdevHomePage.propTypes = PageStrictPropTypes({
});

module.exports = AppdevHomePage;


// WEBPACK FOOTER //
// ./modules/components/appdev/AppdevHomePage.js